enum EGeneratorType {
  LICENSE_POOL = 'license_pool',
  INFORMATIONAL_EMAIL = 'informational_email',
  WEB_SERVICE = 'web_service',
  TEST_WEB_SERVICE = 'test_web_service',
}

export default EGeneratorType;
